import { INew_TableAction, ITimePeriodRequest } from '@lla-platform/core/core-data-access'
import { IEditLocationAttentionRequest } from '../../interfaces/shops.interface'
import {
  ICopyPreferredVendorsRequest,
  IUpdatePreferredVendorsRequest
} from '../../interfaces/vendors.interface'

export class GetAllShops {
  static readonly type = '[shops] Get All Shops'
}

export class GetStatusBoard {
  static readonly type = '[shops] Get Status Board'
}

export class GetAttentionSummary {
  static readonly type = '[shops] Get Attention Summary'
}

export class EditLocationAttention {
  static readonly type = '[shops] Edit Location Attention'
  constructor(
    public locationId: string,
    public payload: IEditLocationAttentionRequest
  ) {}
}

export class GetAllVendors {
  static readonly type = '[shops] Get All Vendors'
  constructor(public payload: ITimePeriodRequest) {}
}

export class GetVendorsList {
  static readonly type = '[shops] Get Vendors List'
  constructor(public info: INew_TableAction) {}
}

export class GetVendorDocument {
  static readonly type = '[shops] Get Vendor Document'
  constructor(public vendorDocumentId: string) {}
}

export class GetVendorsSummaryByLevel {
  static readonly type = '[shops] Get Vendors Summary By Level'
  constructor(public payload: ITimePeriodRequest) {}
}

export class GetPreferredVendors {
  static readonly type = '[shops] Get Preferred Vendors'
}

export class GetPreferredVendorsDetail {
  static readonly type = '[shops] Get Preferred Vendors Detail'
  constructor(public locationId: string) {}
}

export class UpdatePreferredVendors {
  static readonly type = '[shops] Update Preferred Vendors'
  constructor(
    public locationId: string,
    public payload: IUpdatePreferredVendorsRequest
  ) {}
}

export class CopyPreferredVendors {
  static readonly type = '[shops] Copy Preferred Vendors'
  constructor(
    public locationId: string,
    public payload: ICopyPreferredVendorsRequest
  ) {}
}

export class GetAllRegionalManagers {
  static readonly type = '[shops] Get All Regional Managers'
}

export class GetAllDistrictManagers {
  static readonly type = '[shops] Get All District Managers'
}

export class GetAllLocationGroups {
  static readonly type = '[shops] Get All Location Groups'
}

export class UpdateLocationUsafWarehouse {
  static readonly type = '[shops] Update Location Usaf Warehouse'
  constructor(
    public locationId: string,
    public usafWarehouse: string
  ) {}
}
